import axios from "axios";
import Config from "../config";

export const laravelService = axios.create({
  baseURL: `${Config.laravelUrl}/api/`,
  timeout: 70000,
});
